import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import DeviceInfoCard from './DeviceInfoCard';
import { commonGetService } from '../../utils/properties';
import { useAppSelector } from '../../app/hooks';
import { useParams } from 'react-router';

export interface DeviceInfoData {
    title: string,
    value: string
}

const DeviceInfo = () => {
    const [rowData, setRowData] = useState<DeviceInfoData[][]>([]);

    const filterData = useAppSelector((state) => state.filterData);
    const { empDeviceId } = filterData; // Destructuring the filterData state value
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const { empid } = useParams();


    const formatDeviceInfo = (data: any[]): DeviceInfoData[][] => {
        if (!data?.length) {
            return [
                [
                    { title: 'Device ID', value: 'N/A' },
                    { title: 'Created At', value: 'N/A' },
                    { title: 'Updated At', value: 'N/A' }
                ],
                [
                    { title: 'App Version', value: 'N/A' },
                    { title: 'Install Date', value: 'N/A' },
                    { title: 'Last Active Date', value: 'N/A' }
                ],
                [
                    { title: 'Installation Source', value: 'N/A' },
                    { title: 'Sync Status', value: 'N/A' },
                    { title: 'Network Status', value: 'N/A' }
                ],
                [
                    { title: 'Data Transfer Status', value: 'N/A' },
                    { title: 'Last Sync Timestamp', value: 'N/A' },
                    { title: 'Previous Device ID', value: 'N/A' }
                ],
                [
                    { title: 'Device Status', value: 'N/A' },
                    { title: 'Error Logs', value: 'N/A' },
                    { title: 'OS Information', value: 'N/A' }
                ],
                [
                    { title: 'Remarks / Comments', value: 'N/A' }
                ]
            ];
        }
        const device = data[0];

        return [
            [
                { title: 'Device ID', value: device.device_id ?? 'N/A' },
                { title: 'Created At', value: device.created_at ?? 'N/A' },
                { title: 'Updated At', value: device.updated_at ?? 'N/A' }
            ],
            [
                { title: 'App Version', value: device.app_version ?? 'N/A' },
                { title: 'Install Date', value: device.install_date ?? 'N/A' },
                { title: 'Last Active Date', value: device.last_active_date ?? 'N/A' }
            ],
            [
                { title: 'Installation Source', value: device.installation_source ?? 'N/A' },
                { title: 'Sync Status', value: device.sync_status ?? 'N/A' },
                { title: 'Network Status', value: device.network_status ?? 'N/A' }
            ],
            [
                { title: 'Data Transfer Status', value: device.data_transfer_status ?? 'N/A' },
                { title: 'Last Sync Timestamp', value: device.last_sync_timestamp ?? 'N/A' },
                { title: 'Previous Device ID', value: device.previous_device_id ?? 'N/A' }
            ],
            [
                { title: 'Device Status', value: device.device_status ?? 'N/A' },
                { title: 'Error Logs', value: device.error_logs ?? 'N/A' },
                { title: 'OS Information', value: device.os_information ?? 'N/A' }
            ],
            [
                { title: 'Remarks / Comments', value: device.remarks ?? 'N/A' }
            ]
        ];
    };


    useEffect(() => {
        getDeviceInfo();
    }, [empid])

    const getDeviceInfo = () => {
        commonGetService(`/api/1.0/employee/devices/info?emp_code=${empid ?? empDeviceId}`).then(res => {
            if (res.status === 200) {
                setRowData(formatDeviceInfo(res.data));
            }
            setIsLoading(false);

        })
    }
    const osInfo = rowData
        .flat()
        .find(item => item.title === 'OS Information')?.value ?? "";


    return (
        <div className='device-info-cont'>
            {isLoading ? (
                <div className="d-flex justify-content-center align-items-center h-100 w-100 crt-loader">
                    <img src="/images/loader/content_loader.gif" />
                </div>
            ) : (
                <>
                    {rowData?.map((res, i) => (
                        <DeviceInfoCard
                            deviceData={res}
                        />
                    ))}
                    <div className='d-divider'></div>
                    <DeviceInfoCard
                        deviceData={[{ title: 'OS Information', value: osInfo }]}
                    />
                </>)}
        </div>
    );
};

export default DeviceInfo;